import { render, staticRenderFns } from "./ErpDlsReturnsTui.vue?vue&type=template&id=2f701fe5&scoped=true&"
import script from "./ErpDlsReturnsTui.vue?vue&type=script&lang=js&"
export * from "./ErpDlsReturnsTui.vue?vue&type=script&lang=js&"
import style0 from "./ErpDlsReturnsTui.vue?vue&type=style&index=0&id=2f701fe5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f701fe5",
  null
  
)

export default component.exports